import { Search } from "lucide-react";
import { Link } from "@/lib/nav";
import { ReactNode } from "react";

import { Button } from "@buildpy/ui/button";
import { Input } from "@buildpy/ui/input";
import { cn } from "@/lib/utils";

interface FilterBarProps {
  action: string;
  children: ReactNode;
  resetHref?: string;
  filtered?: boolean;
  className?: string;
}

// 목록 위 검색·셀렉트 줄 — GET 폼이라 값이 URL 에 살고, 걸린 조건이 있을 때만 끝에 고스트 「초기화」 가 붙는다.
const FilterBar = ({ action, children, resetHref, filtered = false, className }: FilterBarProps) => (
  <form action={action} className={cn("flex flex-wrap items-center gap-2", className)} method="get">
    {children}
    {resetHref && filtered && (
      <Button asChild size="sm" variant="ghost">
        <Link href={resetHref}>초기화</Link>
      </Button>
    )}
  </form>
);

interface SearchFieldProps {
  name: string;
  "aria-label": string;
  defaultValue?: string;
  placeholder?: string;
  className?: string;
}

// 필터바의 첫 칸 — 시각 라벨이 없으니 aria-label 이 필수이고, 가장 넓게 늘어난다.
const SearchField = ({ name, "aria-label": ariaLabel, defaultValue, placeholder, className }: SearchFieldProps) => (
  <div className={cn("relative min-w-56 flex-1", className)}>
    <Search
      aria-hidden
      className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
    />
    <Input
      adornment="start"
      aria-label={ariaLabel}
      defaultValue={defaultValue}
      inputSize="sm"
      name={name}
      placeholder={placeholder}
      type="search"
    />
  </div>
);

export { FilterBar, SearchField };
